import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import Popup from '../../Reusable_Components/Popup';


const TableList = ({ tableArray, setisEditing, setTableData }) => {

    const [showWarning, setShowWarning] = useState(false);
    const [dataToDelete, setDataToDelete] = useState(null);

    const handleEdit = (data) => {
        setisEditing(true);
        setTableData(data)
    }

    const handleDelete = async()=>{
        console.log("data to delete is", dataToDelete);
    }

    return (
        <div>


            {showWarning &&
                <Popup>
                    <div className="py-3 px-4 ">

                    <div className="flex items-center">
                        <svg className="text-red-500" fill="currentColor" width="16" height="16" class="bi bi-exclamation-circle-fill" viewBox="0 0 16 16">
                            <path  fill="currentColor" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
                        </svg>
                        <h4 className="text-gray-700 font-semibold ml-2">Warning !</h4>
                    </div>

                        <h4 className="text-gray-600  my-5">Do you really want to delete the table forver ?</h4>
                        
                        <div className="flex items-center">
                        <p className="text-green-500 cursor-pointer" onClick={()=>setShowWarning(false)}>Cancel</p>
                        <button onClick={()=>handleDelete()} className="px-3 py-1 ml-4 text-white rounded-sm bg-red-500 hover:bg-red-700">Delete</button>
                        </div>
                    </div>
                </Popup>
            }


            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th
                                scope="col"
                                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                ID
                            </th>
                            <th
                                scope="col"
                                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                Name
                            </th>
                            <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                Seating
                            </th>

                            <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                Mergeable
                            </th>

                            <th scope="col" className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                Status
                            </th>


                            <th
                                scope="col"
                                className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                            >
                                Action
                            </th>

                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {
                            tableArray.map((table, index) => {
                                return (
                                    <tr key={index}>
                                        <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                                            {table._id || 'N/A'}
                                        </td>
                                        <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                                            {table.tableName || 'N/A'}
                                        </td>
                                        <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                                            {table.capacity || 'N/A'}
                                        </td>
                                        <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                                            {table.mergeable && 'true' || 'False'}
                                        </td>
                                        <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">
                                            {table.currentStatus || 'N/A'}
                                        </td>
                                        <td className="px-3 py-4 flex items-center whitespace-nowrap text-sm font-medium text-gray-600 cursor-pointer hover:text-indigo-500">

                                            <svg onClick={() => { handleEdit(table) }} className="edit-svg-icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M16 2H8C4.691 2 2 4.691 2 8V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H16C19.309 22 22 19.309 22 16V8C22 4.691 19.309 2 16 2ZM8.999 17H7V15.001L12.53 9.479L14.529 11.478L8.999 17ZM15.472 10.535L13.473 8.536L14.997 7.013L16.996 9.012L15.472 10.535V10.535Z" />
                                            </svg>
                                            &nbsp;  &nbsp;
                                            <svg onClick={() =>{ setShowWarning(true) ;  setDataToDelete(table) }} xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                                                <path className="text-red-500 hover:text-red-600" d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                                <path className="text-red-500 hover:text-red-600" fill-rule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                            </svg>

                                        </td>
                                    </tr>
                                )
                            }
                            )
                        }

                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default TableList;
